import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import type { TFunction } from 'i18next';
import { getToken } from '../session';

const exportLeads = async (t: TFunction, leadIds?: string[], secret?: string) => {
    const token = getToken();
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
    };

    const body: Record<string, unknown> = {};
    if (leadIds) {
        body.leadIds = leadIds;
    }
    if (secret) {
        body.secret = secret;
    }

    const response = await fetch(`/api/rest/leads/export`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
    });

    if (response.status !== 200) {
        throw new Error('Failed to export leads');
    }

    const blob = await response.blob();
    const format = 'YYYYMMDD';
    const date = dayjs(new Date()).format(format);

    return saveAs(blob, t('leads:download.filename', { date }));
};

export default exportLeads;
